import get from 'lodash/get'
import { STATES, IState } from 'constants/countriesStates'

/**
 * @example getStatesByCountry('US') // [{ abbr: 'AL', name: 'Alabama' }, ...]
 */
export const getStatesByCountry = (countryKey: string): IState[] => {
  return get(STATES, countryKey, [])
}
